import { polymorphicFactory, Box, Grid, GridColumn, RevealOnView, Typography, DsmColor, omitText, Flex, Link, AspectRatioKeeper, Video, Image } from '@kohler-dsm-library/kohler-core';
import { clsx } from 'clsx';
import React, { isValidElement } from 'react';
import classes from './ProductListHero.module.css.mjs';
import { ProductItem } from './subcomponents/ProductItem/ProductItem.mjs';

const ProductListHero = polymorphicFactory(
  (props, ref) => {
    const {
      component = "section",
      mod,
      heading,
      copy,
      image,
      CTAs,
      products,
      video,
      productsReveal,
      CTAsReveal,
      className,
      ...rest
    } = props;
    const { reveal: headingReveal, ...headingForTypography } = heading ?? {};
    const { reveal: copyReveal, ...copyForTypography } = copy ?? {};
    const { reveal: videoReveal, ...videoRest } = video ?? {};
    const { reveal: imageReveal, ...imageRest } = image ?? {};
    return /* @__PURE__ */ React.createElement(
      Box,
      {
        component,
        ref,
        mod,
        className: clsx("kohler-product-list-hero-root", classes.productListHero, className),
        ...rest
      },
      /* @__PURE__ */ React.createElement(Grid, { className: classes.productListHeroInnerWrapper }, /* @__PURE__ */ React.createElement(GridColumn, { className: classes.productListHeroContentWrapper }, /* @__PURE__ */ React.createElement(RevealOnView, { ...headingReveal }, /* @__PURE__ */ React.createElement(
        Typography,
        {
          component: heading.component || "h1",
          ...omitText(headingForTypography),
          size: "h2",
          textColor: DsmColor.ContentPrimary
        },
        heading.text
      )), (copy || CTAs) && /* @__PURE__ */ React.createElement(Flex, { direction: "column", className: classes.productListHeroCopyCTAWrapper }, copy && /* @__PURE__ */ React.createElement(RevealOnView, { ...copyReveal }, /* @__PURE__ */ React.createElement(
        Typography,
        {
          component: isValidElement(copy.text) ? "div" : copy.component || "p",
          ...omitText(copyForTypography),
          size: "paragraph-large",
          textColor: DsmColor.ContentSecondary
        },
        copy.text
      )), CTAs && /* @__PURE__ */ React.createElement(RevealOnView, { ...CTAsReveal }, /* @__PURE__ */ React.createElement(Flex, { align: "center", columnGap: "40px", rowGap: "15px", justify: "center", wrap: "wrap" }, CTAs.map((CTA, index) => /* @__PURE__ */ React.createElement(Link, { size: "large", key: index, ...omitText(CTA) }, CTA.text)))))), products && /* @__PURE__ */ React.createElement(RevealOnView, { style: { gridColumn: "1 / -1" }, ...productsReveal }, /* @__PURE__ */ React.createElement(Flex, { component: "ul", className: clsx(classes.productListHeroProducts, classes.productListHeroPaddings) }, products.map((product) => /* @__PURE__ */ React.createElement(Flex, { component: "li", key: product.title.text }, /* @__PURE__ */ React.createElement(ProductItem, { ...product }))))), (video || image) && /* @__PURE__ */ React.createElement(Flex, { className: clsx(classes.productListHeroPaddings) }, /* @__PURE__ */ React.createElement(RevealOnView, { ...videoReveal || imageReveal, style: { width: "100%" } }, /* @__PURE__ */ React.createElement(AspectRatioKeeper, { className: clsx(classes.productListHeroImageAspectRatio) }, video ? /* @__PURE__ */ React.createElement(
        Video,
        {
          controls: false,
          loop: true,
          muted: true,
          autoPlay: true,
          playsInline: true,
          autoplayInView: true,
          decorative: true,
          ...videoRest
        }
      ) : image && /* @__PURE__ */ React.createElement(Image, { ...imageRest })))))
    );
  }
);

export { ProductListHero };
